import { render, staticRenderFns } from "./DocumentManagementModal.vue?vue&type=template&id=e81a283a"
import script from "./DocumentManagementModal.vue?vue&type=script&lang=js"
export * from "./DocumentManagementModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports